<template>
  <el-card
    class="background"
    v-loading="loadingPage"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="contract-maintainance">
      <el-collapse v-model="activeCollapses" class="collapse-main-content">
        <!-- 基本信息 -->
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              基本信息
            </div>
          </template>
          <div class="collapse-content">
            <SiruiSearch
              ref="baseInfoFormRef"
              :query="baseInfoData"
              :columns="baseColumns"
              :rules="baseRules"
              :isQueryPanel="false"
              @changeMethod="changeMethod"
              labelWidth="120px"
              :isDisabledForm="isDisabledForm"
            >
            </SiruiSearch>
          </div>
        </el-collapse-item>
        <!-- 合同行信息 -->
        <el-tabs class="editCooperationTabs" type="border-card" v-model="activeTabName">
          <el-tab-pane label="合同行信息" name="contractTab">
            <WarehouseCostTable
              :showTableBtn="showTableBtn"
              :tableDataList="expenseList"
              :goodsType="childrenGoodsTypeList"
              :goodsCategoryRow="goodsCategoryList"
              :isDisabled="isDisabled"
              :commodityTypeCode="baseInfoData.productCategoryCode"
              :commodityClassificationRow="productCategoryList"
              ref="warehouseCostTable"
            ></WarehouseCostTable>
            <LoadCostTable
              :showTableBtn="showTableBtn"
              :tableDataList="rateList"
              :isDisabled="isDisabled"
              :goodsType="childrenGoodsTypeList"
              :goodsCategoryRow="goodsCategoryList"
              :commodityTypeCode="baseInfoData.productCategoryCode"
              :commodityClassificationRow="productCategoryList"
              ref="LoadCostTable"
            ></LoadCostTable>
            <SpecialCostTable
              :showTableBtn="showTableBtn"
              :tableDataList="specialList"
              :isDisabled="isDisabled"
              :goodsType="childrenGoodsTypeList"
              :goodsCategoryRow="goodsCategoryList"
              :commodityTypeCode="baseInfoData.productCategoryCode"
              :commodityClassificationRow="productCategoryList"
              ref="SpecialCostTable"
            ></SpecialCostTable>
          </el-tab-pane>
          <template v-if="pageMode == 1 && history == null">
            <el-tab-pane label="库存记录同步" name="inventoryRecordTab">
              <InventoryRecordTable
                ref="inventoryRecordTab"
                :contractNo="baseInfoData.contractNo"
                :tableDataList="this.inventoryList"
              ></InventoryRecordTable>
            </el-tab-pane>
            <el-tab-pane label="历史执行情况" name="historicalExecutionTab">
              <el-collapse v-model="historyExecuteActiveNames" class="collapse-main-content">
                <el-collapse-item name="1">
                  <template slot="title">
                    <div class="collapse-title-pre">
                      <span></span>
                      收款信息
                    </div>
                  </template>
                  <div class="collapse-content">
                    <HistoricalExecutionTable
                      ref="historyExecuteTableRef"
                      :fetchTableData="historicalList"
                    />
                  </div>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    <div class="collapse-title-pre">
                      <span></span>
                      发票信息
                    </div>
                  </template>
                  <div class="collapse-content">
                    <InvoiceInformationExpandTable
                      ref="invoiceInformationExpandTableRef"
                      :fetchTableData="invoiceList"
                    />
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <el-tab-pane label="审批记录" name="approvalRecordTab">
              <ApprovalRecordTable :tableDataList="approvalRecordVOList"></ApprovalRecordTable>
            </el-tab-pane>
            <el-tab-pane label="变更记录" name="changeRecordTab">
              <ChangeRecordTable :tableDataList="historyVOList"></ChangeRecordTable>
            </el-tab-pane>
          </template>
        </el-tabs>
        <!-- 附件上传 -->
        <el-collapse-item name="3">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              附件上传
            </div>
          </template>
          <div class="collapse-content">
            <FileTable
              ref="fileTableRef"
              :isShowDownBtn="this.disableButtons"
              :isDisabledDelete="this.isDisabledDelete"
              :isDisabledUpload="this.isDisabledUpload"
              :attachments="attachments"
            />
          </div>
        </el-collapse-item>
        <!-- 审批 -->
        <el-collapse-item name="4" v-if="this.pageMode == 2">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              审批
            </div>
          </template>
          <div class="collapse-content">
            <ContractApprovalForm ref="contractApprovalForm" />
          </div>
        </el-collapse-item>
        <!-- 底部按钮 -->
        <footer class="bottomButtons">
          <DetailFooterButtonsVue
            @btnHandler="btnHandler"
            :contractStatus="baseInfoData.contractStatus"
          />
        </footer>
        <CloseContractDialog
          ref="closeContractRef"
          :id="this.id"
          :isPaid="true"
        ></CloseContractDialog>
      </el-collapse>
      <ChangeSubjectDialog ref="changeSubjectRef" :row="baseInfoData.id"></ChangeSubjectDialog>
    </div>
  </el-card>
</template>

<script>
  import { tableCreateColumns, tableDetailColumns } from './columns/tableColumns.js';
  import { rules } from './columns/rules';
  import DetailFooterButtonsVue from './components/DetailFooterButtons.vue';
  import LoadCostTable from './components/loadCostTable/index.vue';
  import SpecialCostTable from './components/specialCostTable/index.vue';
  import WarehouseCostTable from './components/warehouseCostTable/index.vue';
  import InventoryRecordTable from './components/inventoryRecordTable/index.vue';
  import ChangeRecordTable from './components/changeRecordTable/index.vue';
  import ApprovalRecordTable from './components/approvalRecordTable/index.vue';
  import HistoricalExecutionTable from './components/historicalExecutionTable/index.vue';
  import InvoiceInformationExpandTable from './components/InvoiceInformationExpandTable/index.vue';
  import CloseContractDialog from './components/closeContractDialog.vue';
  import FileTable from '@/components/business/FileTable/index.vue';
  import ContractApprovalForm from './components/contractApprovalForm/index.vue';
  import ChangeSubjectDialog from './components/changeSubjectDialog.vue';
  import detailBtnGroupMixin from '../mixins/detailBtnGroupMixin';
  import goodsApi from '@/api/masterData/goods.js';
  import API from '@/api/park/contract';
  import projectApi from '@/api/park/project';
  export default {
    name: 'contractMaintainance',
    mixins: [detailBtnGroupMixin],
    data() {
      return {
        loadingPage: false,
        baseInfoData: {
          customerContactOne: undefined,
          contactNumberOne: undefined,
          contactEmailOne: undefined,
        },
        uploadTableData: [],
        activeCollapses: ['1', '2', '3', '4'],
        historyExecuteActiveNames: ['1', '2'],
        approvalRecordVOList: [], //审批记录
        attachments: [], //附件
        expenseList: [], //仓储费率行
        historyVOList: [], //变更记录
        rateList: [], //装卸费率行
        specialList: [], // 特殊费用行
        invoiceList: [], //发票信息
        historicalList: [], //收款信息
        inventoryList: [], //库存记录
        goodsTypeList: [], // 货物大类
        goodsCategoryList: [], // 货物品类
        contractStatusList: [], //合同状态
        childrenGoodsTypeList: [], //传给子组件的货物类型
        goodsCategory: '',
        contractStatus: '',
        pageMode: null, //0-新增 1-详情 2-审批 3-续签 4-合同信息变更 5-关闭
        id: null,
        activeTabName: 'contractTab',
        disableButtons: true, //控制附件按钮
        showTableBtn: false, //控制可编辑表格按钮
        isDisabledForm: false, //控制详情表单是否能编辑
        isDisabled: true, //控制可编辑表格是否能编辑
        isDisabledDelete: false, //控制上传附件禁止删除
        isDisabledUpload: true, //控制上传附件禁止新增
        oneFiledList: [
          'customerNameOne',
          'customerCodeOne',
          'customerContactOne',
          'contactNumberOne',
          'contactEmailOne',
        ],
        twoFiledList: [
          'customerNameTwo',
          'customerCodeTwo',
          'customerContactTwo',
          'contactNumberTwo',
          'contactEmailTwo',
        ],
        threeFiledList: [
          'customerNameThree',
          'customerCodeThree',
          'customerContactThree',
          'contactNumberThree',
          'contactEmailThree',
        ],
        visibleField: [
          'customerNameOne',
          'customerCodeOne',
          'customerContactOne',
          'contactNumberOne',
          'contactEmailOne',
        ], //需要显示的字段
        departmentCode: '',
        companyCode: '',
        contractNo: '',
        projectCode: '',
        contractNatureName: '',
        customerNameOne: '',
        closeAttachments: [],
        valueList: [],
        labelList: [],
        history: false, //是否为历史版本
        isProjectToContract: false, // 是否为项目转合同
        isChangeContract: false, //是否为变更信息
        isCopy: false, //是否为复制合同
        productCategoryCode: null,
        productCategoryList: [], //商品分类
      };
    },
    computed: {
      //初始化搜索表单
      baseColumns() {
        //this.pageMode = this.$route.query.pageMode;
        if (this.pageMode == 0 || this.pageMode == 3 || this.pageMode == 4) {
          return tableCreateColumns(this);
        } else if (this.pageMode == 1 || this.pageMode == 2 || this.pageMode == 5) {
          return tableDetailColumns(this);
        } else {
          return [];
        }
      },
      baseRules() {
        return rules(this);
      },
    },
    mounted() {
      this.pageMode = Number(this.$route.query?.pageMode);
      this.history = this.$route.query?.history;
      this.isCopy = this.$route.query?.isCopy;
      console.log(this.isCopy, '是否为复制合同');
      this.id = this.$route.query?.id;
      this.getProduct();
      this.getGoodsParentApi().then(() => {
        this.initDetail();
        this.projectIntoContract();
        this.getData();
        this.differPageMode();
      }); // 获取商品大类类
      this.departmentCode = this.userInfo.departmentCode;
      this.companyCode = this.userInfo.companyCode;
      this.contractStatusList = this.dictListMap.warehouseContractStatus;
    },
    methods: {
      // 初始化数据
      getData() {
        if (this.pageMode == 0) {
          this.baseInfoData = {
            parkCompany: this.userInfo.companyName,
            businessDepartment: this.userInfo.departmentName,
            departmentCode: this.userInfo.departmentCode,
            operatorName: this.userInfo.personName,
            operatorId: this.userInfo.personNo,
            parkCompanyCode: this.userInfo.companyCode,
            companyCode: this.userInfo.companyCode, //
            contractTypeName: '仓储合同',
            goodsTypeCode: [],
            goodsTypeName: '',
            goodsCategoryCode: [],
            goodsCategoryName: '',
          };
          this.disableButtons = false;
          this.showTableBtn = true;
          console.log(this.baseInfoData, '基本信息');
        }
      },
      // 翻译合同状态
      translateContractStatus(val) {
        this.contractStatus = this.contractStatusList.find((item) => item.value == val)?.label;
      },
      // 获取商品分类
      getProduct() {
        this.loading.startLoading();
        this.$axios.post(goodsApi.GOOD_ATTR_TYPE, {}).then((res) => {
          console.log('res', res);
          if (res.data.code === 0) {
            this.productCategoryList = res.data.data || [];
            if (this.productCategoryList.length)
              this.productCategoryList = this.productCategoryList.map((item) => {
                return {
                  ...item,
                  value: item.categoryCode,
                  label: item.categoryName,
                };
              });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取商品大类数据
      async getGoodsParentApi() {
        let groupCategory = this.baseInfoData.productCategoryCode;
        let groupCategoryName = this.baseInfoData.productCategoryName;
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE_CC, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
          groupCategory,
          groupCategoryName,
        });
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              ...item,
              typeName: item.groupCategoryName,
              typeCode: item.groupCategory,
              value: item.parentProductNo,
              label: item.productChName,
            };
          });
          console.log(data.data, '商品大类数据');
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      // 根据货物类型查询货物品类
      async getGoodsCategoryApi() {
        const productParentCodes = this.goodsTypeList
          .filter((item) => this.baseInfoData.goodsTypeCode.includes(item.value))
          .map((item) => item.value);
        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE, {
          parentProductStatus: 'ZT03',
          productParentCodes,
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsCategoryList = data.data?.map((item) => {
            return {
              ...item,
              value: item.productDetailCode,
              label: item.productChName,
            };
          });
        } else {
          console.error('获取货物类型数据失败');
        }
      },
      // 反填数据
      async initDetail() {
        if (!this.id) {
          this.loading.endLoading();
          return;
        }
        this.loading.startLoading();
        let res;
        if (this.history == null) {
          res = await this.$axios.post(`${API.GET_CONTRACT_DETAIL}/${this.id}`);
        } else {
          res = await this.$axios.post(`${API.QUERY_HISTORY_VISION}/${this.id}`);
        }
        const data = res.data;
        if (data.code == 0) {
          const {
            expenseList,
            rateList,
            specialList,
            approvalRecordVOList,
            attachments,
            historyVOList,
            list,
            ...formData
          } = data.data;
          this.contractNo = formData.contractNo;
          this.approvalRecordVOList = approvalRecordVOList; //审批记录
          this.attachments = attachments; // 附件
          this.expenseList = expenseList; // 仓储费率行信息
          this.historyVOList = historyVOList; // 变更记录
          this.rateList = rateList; // 装卸费率行信息
          this.specialList = specialList; // 特殊费用行信息
          this.baseInfoData = formData; //基本信息
          this.inventoryList = list; //库存记录
          const contractNatureName = formData.contractNatureName;
          this.filterFormField(contractNatureName);
          const defaultPenaltyRate = String(formData.defaultPenaltyRate);
          this.baseInfoData.defaultPenaltyRate =
            defaultPenaltyRate == 'null' ? ' ' : defaultPenaltyRate;
          this.baseInfoData.goodsTypeCode = this.goodsTransferArray(formData.goodsTypeCode);
          this.baseInfoData.goodsCategoryCode = this.goodsTransferArray(formData.goodsCategoryCode);
          this.baseInfoData.goodsTypeName = this.goodsTransferArray(formData.goodsTypeName);
          this.baseInfoData.goodsCategoryName = this.goodsTransferArray(formData.goodsCategoryName);
          this.translateContractStatus(formData.contractStatus);
          this.getGoodsParentApi();
          this.getGoodsCategoryApi();
          this.getInvoiceFormation(formData.contractNo);
          this.getReceivedFormation(formData.contractNo, formData.dateStart, formData.dateEnd);
          this.sendGoodsTypeList(this.baseInfoData.goodsTypeCode);
          // if (this.pageMode != 2) {
          //   await this.$refs.inventoryRecordTab.getTableData(this.baseInfoData.contractNo); //获取库存记录
          // }
        } else {
          this.loading.endLoading();
          console.error('获取数据失败');
        }
      },
      // 获取库存记录数据
      // async getInventoryList() {
      //   console.log('进入方法');
      //   let res = await this.$axios.post(`${API.QUERYINVENTORY}`, {
      //     contractNo: this.baseInfo.contractNo,
      //     pageNum: 1,
      //     pageSize: 10,
      //   });
      //   this.inventoryList = res.data.data.map((item) => {
      //     return {
      //       ...item,
      //       toAmount: item.orderType == 'CK' ? item.weight : '',
      //       enterAmount: item.orderType == 'RK' ? item.weight : '',
      //     };
      //   });
      //   console.log('res', res);
      // },
      sendGoodsTypeList(array) {
        array.forEach((item) => {
          const demo = this.goodsTypeList.find((item1) => {
            if (item == item1.value) return item1;
          });
          this.childrenGoodsTypeList.push(demo);
        });
      },
      // 拼接子类商品类型列表
      /* spliceChildGoodsTypeList(valueList, labelList) {
          valueList.forEach((value, index) => {
            const obj = {};
            obj.value = value;
            obj.label = labelList[index];
            this.childrenGoodsTypeList.push(obj);
          });
          console.log(this.childrenGoodsTypeList, '子类商品类型列表');
        }, */
      // 将商品类型编码字符串转换为数组
      goodsTransferArray(val) {
        let str = [];
        if (val) {
          str = val.split(',');
        } else {
          str = null;
        }
        console.log(str, '商品类型字符串转数组');
        return str;
      },
      // 得到发票信息
      async getInvoiceFormation(val) {
        const { data } = await this.$axios.post(`${API.QUERY_INVOICE}/${val}`);
        const { invoiceAmount, invoicedAmount, invoiceInfos } = data.data;
        console.log(data.data, '表格数据');
        if (data.data.length) {
          this.invoiceList = [
            {
              invoiceAmount: invoiceAmount,
              invoicedAmount: invoicedAmount,
              invoiceInfos: invoiceInfos,
            },
          ];
        }
      },
      // 得到收款信息
      async getReceivedFormation(val, dateStart, dateEnd) {
        const { data } = await this.$axios.post(API.QUERY_RECEIVED, { salesOrderNo: val });
        this.loading.endLoading();
        // const {
        //   receivedType,
        //   originReceiveMoneyAmount,
        //   localReceiveMoneyAmount,
        //   fundCollectionOrderList,
        // } = data.data;
        // console.log(data.data, '收款信息');
        if (data.data?.length) {
          this.historicalList = data.data.map((item) => {
            return {
              payService: item.receivedType,
              dateStart: dateStart,
              dateEnd: dateEnd,
              totalAmount: item.originReceiveMoneyAmount,
              receivedAmount: item.localReceiveMoneyAmount,
              fundCollectionOrderList: item.fundCollectionOrderList,
            };
          });
          // [
          // {
          //   payService: receivedType,
          //   dateStart: dateStart,
          //   dateEnd: dateEnd,
          //   totalAmount: originReceiveMoneyAmount,
          //   receivedAmount: localReceiveMoneyAmount,
          //   fundCollectionOrderList: fundCollectionOrderList,
          // },
          // ];
        }
      },
      // 下拉框改变事件
      changeMethod(row) {
        console.log('row====>', row);
        if (row.prop == 'bankDeposit') {
          this.baseInfoData = {
            ...this.baseInfoData,
            bankDeposit: row.val[0].bankName,
          };
        } else if (row.prop == 'warehouseName') {
          this.baseInfoData = {
            ...this.baseInfoData,
            warehouseName: row.val[0].storageName,
            warehouseCompany: row.val[0].companyName,
          };
        } else if (row.prop == 'projectCode') {
          this.baseInfoData = {
            ...this.baseInfoData,
            projectName: row.val[0].projectName,
            projectCode: row.val[0].projectCode,
          };
        } /* else if (row.prop == 'warehouseCompany') {
            this.baseInfoData = {
              ...this.baseInfoData,
              warehouseCompany: row.val[0].companyName,
            };
          } */ else if (row.prop == 'customerNameOne') {
          // console.log('row.val[0]', row.val[0]);
          this.baseInfoData = {
            ...this.baseInfoData,
            customerCodeOne: row.val[0].partnerCode,
            customerNameOne: row.val[0].partnerZhName,
            // customerContactOne: row.val[0].contactPersonName, //联系人
            // contactNumberOne: row.val[0].contactPhone, //联系电话
            // contactEmailOne: row.val[0].email, //联系邮箱
            /* taxpayerName: row.val[0].companyName,
              taxpayerIdentificationNumber: row.val[0].creditCode,
              bankDeposit: row.val[0].invoiceBankName,
              bankAccount: row.val[0].invoiceBankAccount, */
          };
          console.log(this.baseInfoData, '基本信息');
          if (
            this.baseInfoData.customerCodeTwo &&
            row.val[0].partnerCode == this.baseInfoData.customerCodeTwo
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeOne = null;
            this.baseInfoData.customerNameOne = null;
          } else if (
            this.baseInfoData.customerCodeThree &&
            row.val[0].partnerCode == this.baseInfoData.customerCodeThree
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeOne = null;
            this.baseInfoData.customerNameOne = null;
          } else {
            console.log('one');
            this._assignAdditionalInfo(row.val[0].partnerCode, 'one');
          }
        } else if (row.prop == 'customerNameTwo') {
          this.baseInfoData.customerCodeTwo = row.val[0].partnerCode;
          this.baseInfoData.customerNameTwo = row.val[0].partnerZhName;
          if (
            this.baseInfoData.customerCodeOne &&
            row.val[0].partnerCode == this.baseInfoData.customerCodeOne
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeTwo = null;
            this.baseInfoData.customerNameTwo = null;
          } else if (
            this.baseInfoData.customerCodeThree &&
            row.val[0].partnerCode == this.baseInfoData.customerCodeThree
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeTwo = null;
            this.baseInfoData.customerNameTwo = null;
          } else {
            this._assignAdditionalInfo(row.val[0].partnerCode, 'two');
          }
        } else if (row.prop == 'customerNameThree') {
          this.baseInfoData.customerCodeThree = row.val[0].partnerCode;
          this.baseInfoData.customerNameThree = row.val[0].partnerZhName;
          if (
            this.baseInfoData.customerCodeOne &&
            row.val[0].partnerCode == this.baseInfoData.customerCodeOne
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeThree = null;
            this.baseInfoData.customerNameThree = null;
          } else if (
            this.baseInfoData.customerCodeTwo &&
            row.val[0].partnerCode == this.baseInfoData.customerCodeTwo
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeThree = null;
            this.baseInfoData.customerNameThree = null;
          } else {
            this._assignAdditionalInfo(row.val[0].partnerCode, 'three');
          }
        } else if (row.prop == 'contractNatureName') {
          this.filterFormField(row.val);
        } else if (row.prop == 'goodsTypeCode') {
          this.childrenGoodsTypeList = [];
          let arrGoodsTypeName = [];
          row.val.forEach((element) => {
            const item1 = this.goodsTypeList.find((item) => {
              if (item.value == element) {
                return item;
              }
            });
            this.childrenGoodsTypeList.push(item1);
            arrGoodsTypeName.push(item1.label);
          });
          // 清空下面表格的商品数据
          this.$refs.warehouseCostTable.goodsTypeChage();
          this.$refs.SpecialCostTable.goodsTypeChage();
          this.$refs.LoadCostTable.goodsTypeChage();
          console.log(this.childrenGoodsTypeList, '传给子组件的货物类型');
          this.baseInfoData.goodsTypeName = arrGoodsTypeName.toString();
          this.baseInfoData.goodsCategoryCode = [];
          this.getGoodsCategoryApi();
        } else if (row.prop == 'goodsCategoryCode') {
          let arrGoodsCategoryName = [];
          row.val.forEach((element) => {
            const item1 = this.goodsCategoryList.find((item) => {
              if (item.value == element) {
                return item;
              }
            });
            arrGoodsCategoryName.push(item1.label);
          });
          this.baseInfoData.goodsCategoryName = arrGoodsCategoryName.toString();
        } else if (row.prop == 'productCategoryCode') {
          this.baseInfoData.goodsTypeCode = [];
          this.baseInfoData.goodsTypeName = [];
          this.baseInfoData.productCategoryName = this.productCategoryList.find(
            (item) => item.value == row.val
          )?.label;
          this.baseInfoData.productCategoryId = this.productCategoryList.find(
            (item) => item.value == row.val
          )?.id;
          this.getGoodsParentApi();
          this.childrenGoodsTypeList = [];
          let arrGoodsTypeName = [];
          // 清空下面表格的商品数据
          this.$refs.warehouseCostTable.goodsTypeChage();
          this.$refs.SpecialCostTable.goodsTypeChage();
          this.$refs.LoadCostTable.goodsTypeChage();
          console.log(this.childrenGoodsTypeList, '传给子组件的货物类型');
          this.baseInfoData.goodsTypeName = arrGoodsTypeName.toString();
          this.baseInfoData.goodsCategoryCode = [];
          this.getGoodsCategoryApi();
        }
      },
      filterFormField(val) {
        if (val == 'PIBT10') {
          this.visibleField = this.oneFiledList;
        } else if (val == 'PIBT11') {
          this.visibleField = [...this.oneFiledList, ...this.twoFiledList];
        } else if (val == 'PIBT12') {
          this.visibleField = [...this.oneFiledList, ...this.twoFiledList, ...this.threeFiledList];
        }
      },
      // 得到项目信息
      async getProjectInfo(val) {
        const { data } = await this.$axios.post(projectApi.DETAIL, {
          projectCode: val,
        });
        let goodsCategory = [];
        let goodsType = [];
        let goodsTypeName = [];
        let goodsCategoryName = [];
        const wmProjectCargos = data.data.wmProjectCargos;
        goodsType = wmProjectCargos.map((item) => {
          return item.cargoType;
        });
        goodsTypeName = wmProjectCargos.map((item) => {
          return item.cargoTypeName;
        });
        goodsCategory = wmProjectCargos.map((item) => {
          return item.cargoCategory;
        });
        goodsCategoryName = wmProjectCargos.map((item) => {
          return item.cargoCategoryName;
        });
        this.sendGoodsTypeList(goodsType);
        console.log(wmProjectCargos, '项目信息');
        if (data.code == 0) {
          this.filterFormField(data.data.projectNature);
          this.baseInfoData = {
            ...this.baseInfoData,
            projectCode: data.data.projectCode,
            projectName: data.data.projectName,
            contractNatureName: data.data.projectNature,
            customerNameOne: data.data.customerNameOne,
            customerNameTwo: data.data.customerNameTwo,
            customerNameThree: data.data.customerNameThree,
            customerCodeOne: data.data.customerCodeOne,
            customerCodeTwo: data.data.customerCodeTwo,
            customerCodeThree: data.data.customerCodeThree,
            customerContactOne: data.data.customerContactPersonOne,
            customerContactTwo: data.data.customerContactPersonTwo,
            customerContactThree: data.data.customerContactPersonThree,
            contactNumberOne: data.data.customerContactPhoneOne,
            contactNumberTwo: data.data.customerContactPhoneTwo,
            contactNumberThree: data.data.customerContactPhoneThree,
            contactEmailOne: data.data.customerContactEmailOne,
            contactEmailTwo: data.data.customerContactEmailTwo,
            contactEmailThree: data.data.customerContactEmailThree,
            goodsTypeCode: goodsType,
            goodsCategoryCode: goodsCategory,
            goodsTypeName,
            goodsCategoryName,
          };
          console.log('this.baseInfoData', this.baseInfoData);
          //this.getGoodsCategoryApi();
          this.contractNatureName = data.data.projectNature;
          this.customerNameOne = data.data.customerNameOne;
        } else {
          this.$message.error('查询数据失败！');
        }
      },
      // 项目转合同信息带出
      projectIntoContract() {
        this.projectCode = this.$route.query?.projectCode;
        if (this.projectCode) {
          this.getProjectInfo(this.projectCode);
          this.getGoodsParentApi();
          this.getGoodsCategoryApi();
          this.isProjectToContract = true;
        }
      },
      // 区分页面状态
      differPageMode() {
        if (this.pageMode == 1 || this.pageMode == 2 || this.pageMode == 5) {
          this.isDisabledForm = true;
          this.disableButtons = true;
          this.isDisabledDelete = true;
          this.isDisabledUpload = true;
        }
        if (this.pageMode == 0 || this.pageMode == 3 || this.pageMode == 4) {
          this.showTableBtn = true;
          this.disableButtons = false;
          this.isDisabledDelete = false;
          this.isDisabledUpload = false;
          this.isDisabled = false;
        }
        if (this.pageMode == 3 || this.pageMode == 4) {
          this.isChangeContract = true;
        }
      },
      async _assignAdditionalInfo(partnerCode, upPartner) {
        console.log('调用新方法');
        let additionalInfo = await this.getPartnerInfo(partnerCode);
        if (!additionalInfo) {
          return;
        }
        let partnersPersons = additionalInfo.partnersPersons;
        if (upPartner == 'one') {
          if (partnersPersons && partnersPersons.length) {
            this.baseInfoData = {
              ...this.baseInfoData,
              customerContactOne: partnersPersons[0].contactPersonName,
              contactNumberOne: partnersPersons[0].mobilePhone,
              contactEmailOne: partnersPersons[0].email,
            };
          }
          this.$forceUpdate();
        } else if (upPartner == 'two') {
          if (partnersPersons && partnersPersons.length) {
            this.baseInfoData = {
              ...this.baseInfoData,
              customerContactTwo: partnersPersons[0].contactPersonName,
              contactNumberTwo: partnersPersons[0].mobilePhone,
              contactEmailTwo: partnersPersons[0].email,
            };
          }
          this.$forceUpdate();
        } else if (upPartner == 'three') {
          if (partnersPersons && partnersPersons.length) {
            this.baseInfoData = {
              ...this.baseInfoData,
              customerContactThree: partnersPersons[0].contactPersonName,
              contactNumberThree: partnersPersons[0].mobilePhone,
              contactEmailThree: partnersPersons[0].email,
            };
          }
          this.$forceUpdate();
        }
      },
      async getPartnerInfo(partnerCode) {
        var { data } = await this.$axios.post('/maindata/partners/getPartnerInfoByCode', {
          partnerCode,
        });
        if (data.code == 0 && data.data) {
          return data.data;
        } else {
          // this.$message({ showClose: true, message: data.msg, type: 'error' });
        }
        return {};
      },
    },
    components: {
      LoadCostTable,
      SpecialCostTable,
      WarehouseCostTable,
      InventoryRecordTable,
      ApprovalRecordTable,
      ChangeRecordTable,
      DetailFooterButtonsVue,
      HistoricalExecutionTable,
      InvoiceInformationExpandTable,
      CloseContractDialog,
      ContractApprovalForm,
      ChangeSubjectDialog,
      FileTable,
    },
  };
</script>

<style lang="scss" scoped>
  .bottomButtons {
    padding-top: 20px;
    text-align: center;
  }
</style>
